var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "border-top-gray" },
                [
                  _c("b-card-header", { staticClass: "px-0 pt-0" }, [
                    _vm._v("Not Started"),
                  ]),
                  _c(
                    "b-card-body",
                    { staticClass: "p-0 drag-container" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: { group: "cards" },
                          on: { change: _vm.onChange },
                          model: {
                            value: _vm.notStarted,
                            callback: function ($$v) {
                              _vm.notStarted = $$v
                            },
                            expression: "notStarted",
                          },
                        },
                        _vm._l(_vm.notStarted, function (task, index) {
                          return _c(
                            "b-card",
                            {
                              key: task.id,
                              style: { border: "2px solid rgb(159, 197, 76)" },
                            },
                            [
                              _c(
                                "b-card-header",
                                { staticClass: "px-0 pt-0" },
                                [
                                  _c(
                                    "b-badge",
                                    {
                                      attrs: {
                                        variant: _vm.getPriorityVariant(
                                          task.priority
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(task.priority) +
                                          " Priority "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-card-body",
                                { staticClass: "p-0" },
                                [
                                  _c("b-card-title", [
                                    _vm._v(_vm._s(task.title)),
                                  ]),
                                  _c("b-card-text", [
                                    _vm._v(_vm._s(task.description)),
                                  ]),
                                  _c("b-card-text", [
                                    _vm._v(
                                      "Sub Tasks (" +
                                        _vm._s(task.totalSubTasks) +
                                        ")"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c("b-card-footer"),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "border-top-info" },
                [
                  _c("b-card-header", { staticClass: "px-0 pt-0" }, [
                    _vm._v("In Progress"),
                  ]),
                  _c(
                    "b-card-body",
                    { staticClass: "p-0 drag-container" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: { group: "cards" },
                          on: { change: _vm.onChange },
                          model: {
                            value: _vm.inProgress,
                            callback: function ($$v) {
                              _vm.inProgress = $$v
                            },
                            expression: "inProgress",
                          },
                        },
                        _vm._l(_vm.inProgress, function (task, index) {
                          return _c(
                            "b-card",
                            {
                              key: task.id,
                              style: { border: "2px solid rgb(159, 197, 76)" },
                            },
                            [
                              _c(
                                "b-card-header",
                                { staticClass: "px-0 pt-0" },
                                [
                                  _c(
                                    "b-badge",
                                    {
                                      attrs: {
                                        variant: _vm.getPriorityVariant(
                                          task.priority
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(task.priority) +
                                          " Priority "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-card-body",
                                { staticClass: "p-0" },
                                [
                                  _c("b-card-title", [
                                    _vm._v(_vm._s(task.title)),
                                  ]),
                                  _c("b-card-text", [
                                    _vm._v(_vm._s(task.description)),
                                  ]),
                                  _c("b-card-text", [
                                    _vm._v(
                                      "Sub Tasks (" +
                                        _vm._s(task.totalSubTasks) +
                                        ")"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "border-top-warning" },
                [
                  _c("b-card-header", { staticClass: "px-0 pt-0" }, [
                    _vm._v("On Hold"),
                  ]),
                  _c(
                    "draggable",
                    {
                      attrs: { group: "cards" },
                      on: { change: _vm.onChange },
                      model: {
                        value: _vm.onHold,
                        callback: function ($$v) {
                          _vm.onHold = $$v
                        },
                        expression: "onHold",
                      },
                    },
                    [
                      _vm._l(_vm.onHold, function (task, index) {
                        return _c(
                          "b-card",
                          {
                            key: task.id,
                            style: { border: "2px solid rgb(159, 197, 76)" },
                          },
                          [
                            _c(
                              "b-card-header",
                              { staticClass: "px-0 pt-0" },
                              [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.getPriorityVariant(
                                        task.priority
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(task.priority) + " Priority "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-card-body",
                              { staticClass: "p-0" },
                              [
                                _c("b-card-title", [
                                  _vm._v(_vm._s(task.title)),
                                ]),
                                _c("b-card-text", [
                                  _vm._v(_vm._s(task.description)),
                                ]),
                                _c("b-card-text", [
                                  _vm._v(
                                    "Sub Tasks (" +
                                      _vm._s(task.totalSubTasks) +
                                      ")"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "border-top-success" },
                [
                  _c("b-card-header", { staticClass: "px-0 pt-0" }, [
                    _vm._v("Completed"),
                  ]),
                  _c(
                    "draggable",
                    {
                      attrs: { group: "cards" },
                      on: { change: _vm.onChange },
                      model: {
                        value: _vm.completed,
                        callback: function ($$v) {
                          _vm.completed = $$v
                        },
                        expression: "completed",
                      },
                    },
                    [
                      _vm._l(_vm.completed, function (task, index) {
                        return _c(
                          "b-card",
                          {
                            key: task.id,
                            style: { border: "2px solid rgb(159, 197, 76)" },
                          },
                          [
                            _c(
                              "b-card-header",
                              { staticClass: "px-0 pt-0" },
                              [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.getPriorityVariant(
                                        task.priority
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(task.priority) + " Priority "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-card-body",
                              { staticClass: "p-0" },
                              [
                                _c("b-card-title", [
                                  _vm._v(_vm._s(task.title)),
                                ]),
                                _c("b-card-text", [
                                  _vm._v(_vm._s(task.description)),
                                ]),
                                _c("b-card-text", [
                                  _vm._v(
                                    "Sub Tasks (" +
                                      _vm._s(task.totalSubTasks) +
                                      ")"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }